import React from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

import "./LibrarySlider.css"

const images = [
	{
		src: "/image/Algeria Djanet.jpg",
		credit: "Picture of Djanet Algeria",
	},
	{
		src: "/image/WILDERNESS Kwetsani Dana Allen.jpg",
		credit: "Picture by Dana Allen",
	},
	{
		src: "/image/WILDERNESS Bisate Gorilla Trek Philip Harvey.jpg",
		credit: "Picture by Philip Harvey",
	},
	{
		src: "/image/WILDERNESS Little Ruckomechi Dana Allen.jpg",
		credit: "Picture by Dana Allen",
	},
	{
		src: "/image/WILDERNESS Little Mombo Alicia Warner.jpg",
		credit: "Picture by Alicia Warner",
	},
]

function LibrarySlider() {
	const settings = {
		infinite: true,
		arrows: true,
		dots: false,
		slidesToShow: 1,
		centerMode: true,
		centerPadding: "12%",
		swipeToSlide: true,
		speed: 500,
		autoplay: true,
		autoplaySpeed: 2000,
	}

	return (
		<div className="library-slider-wrapper">
			<Slider {...settings}>
				{images.map((item, idx) => (
					<div key={idx} className="slick-slide-item">
						<img
							src={item.src}
							alt={`Slide ${idx}`}
							className="library-slide-image"
						/>
						<p className="photo-credit">{item.credit}</p>
					</div>
				))}
			</Slider>
		</div>
	)
}

export default LibrarySlider
